
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminRoutes } from '../admin/routes/AdminRoutes';
import { AuthRoutes } from '../auth/routes/AuthRoutes';
import { HomeRoutes } from '../home/routes/HomeRoutes';
import { useAuthStore } from '../store';
import { CargandoMedio } from '../admin/components';





export const AppRouter = () => {


    const authStatus = useAuthStore(state => state.status);
    const checkStatus = useAuthStore(state => state.startCheckStatus);



    useEffect(() => {
        checkStatus();
    }, [])



    if(authStatus === 'pending'){
        return( <CargandoMedio titulo="Cargando Información..." /> )
    } 
    


    return (
        <Routes>
            {
            ( authStatus === 'unauthorized' )
            ?   (
                <>
                <Route path="/auth/*" element={ <AuthRoutes /> } />
                <Route path="/*" element={ <Navigate to="/home" /> } />
                </>
                )

            :   (
                <>
                <Route path="/admin/*" element={ <AdminRoutes /> } />
                <Route path="/*" element={ <Navigate to="/admin/dasboard" /> } />
                </>
                )
            }

            <Route path="/home/*" element={ <HomeRoutes /> } />
            <Route path="/*" element={ <Navigate to="/home" /> } />
        </Routes>

    )
}
